import { Link } from "@src/Components/Link"
import { tState } from "@src/Model/Model"
import { colors } from "@src/theme"
import { Typography } from "@zeguro/component-library"
import * as React from "react"
import { useSelector } from "react-redux"

import { ErrorPageContainer } from "./styles"

const ErrorPageUsedLink = () => {
  const { emailDomain } = useSelector((state: tState) => state.brand)
  return (
    <ErrorPageContainer>
      <img src="/images/laptop-error-screen.svg" alt="error-screen" />
      <Typography
        variant="heading1"
        margin="25px 0 0 0"
        color={colors.darkBlue}
      >
        Oops!
      </Typography>
      <Typography variant="heading2" margin="0">
        The link is not valid. Check it and try again.
      </Typography>
      <Typography
        variant="title2"
        color={colors.black50}
        lineHeight="32px"
        margin="15px 0 0 0"
      >
        Contact the person who invited you <br /> and ask them to resend your
        invitation.
      </Typography>
      <Typography
        variant="title2"
        color={colors.black50}
        lineHeight="22px"
        margin="15px 0 0 0"
      >
        Still having trouble? Email us at{" "}
        <Link href={`mailto:support@${emailDomain}`}>
          support@{emailDomain}
        </Link>
        .
      </Typography>
    </ErrorPageContainer>
  )
}

export default ErrorPageUsedLink
